module.exports = __webpack_public_path__ + "8ff079b062644e068210078cf2f88c90.svg";